import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loadData, deleteData, addData, updateData } from "../../../../config/data";
import EmptyAsset from "../emptyAsset";
import ISO6391 from "iso-639-1";
import Lang from "../../../../config/lang";
import { useProfileTab } from "../../ProfileTabContext";

const LanguageForm = ({ setIsFading, updatePercentage, profileCompletion }) => {
    const { lang } = useSelector((state) => state.globalReducer);
    const applicantID = localStorage?.getItem("applicantID");
    const userToken = localStorage?.getItem('authToken') || '';
    const { currentTabIndex, setCurrentTabIndex } = useProfileTab();
    const codes = ISO6391.getAllCodes();
    const names = ISO6391.getAllNames();


    const [isEdit, setIsEdit] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [isLoading, setisLoading] = useState('');

    // Load Language Data
    const loadLanguages = async () => {
        loadData({
            url: "LanguageSkills",
            params: [{ title: "filter", value: `applicant:${applicantID}` }],
            userToken,
        }).then((res) => {
            if (res?.data) {
                const resData = res?.data;
                const exists = (resData || []).some(item => item.languageName === "English");
                const english = {
                    languageSkillID: null,
                    applicantID: applicantID,
                    languageName: 'English',
                    speakingProficiency: "",
                    writingProficiency: "",
                };
                if (!exists) {
                    resData?.push(english)
                }
                const newData = (resData?.length === 0) ? [english] : resData;
                newData.sort((a, b) => {
                    if (a.languageName === "English") return -1;
                    if (b.languageName === "English") return 1;
                    return 0;
                });
                setLanguages(newData);
            }
        });
    };

    const isFormReady = () => {
        const hasEmptyId = languages.some(item => !item.languageName || !item.speakingProficiency || !item.writingProficiency);
        return !hasEmptyId;
    }


    useEffect(() => {
        loadLanguages();
    }, []);

    const handleChange = (index, field, value) => {
        const updated = [...languages];
        updated[index][field] = value;
        setLanguages(updated);
    };

    const handleAddLanguage = () => {
        setIsEdit(true)
        setLanguages([
            ...languages,
            {
                languageSkillID: null,
                applicantID: applicantID,
                languageName: '',
                speakingProficiency: "",
                writingProficiency: "",
            },
        ]);
    };

    const handleRemoveLanguage = (lang) => {
        try {
            if (lang.languageSkillID) {
                deleteData({
                    url: `LanguageSkills`,
                    id: lang.languageSkillID,
                    userToken
                }).then(() => {
                    loadLanguages();
                });
            } else {
                setLanguages(languages.filter((l) => l !== lang));
            }
        } catch (error) {
            console.log(error)

        }
    };


    // Save single organization
    const saveLanguage = async (language) => {
        try {
            if (language.languageSkillID) {
                await updateData({
                    url: "LanguageSkills",
                    userToken,
                    reqBody: {
                        languageSkillID: language.languageSkillID,
                        applicantID: applicantID,
                        languageName: language.languageName,
                        speakingProficiency: language.speakingProficiency,
                        writingProficiency: language.writingProficiency,
                    },
                });
            } else {
                await addData({
                    url: "LanguageSkills",
                    userToken,
                    reqBody: {
                        applicantID: applicantID,
                        languageName: language.languageName,
                        speakingProficiency: language.speakingProficiency,
                        writingProficiency: language.writingProficiency,
                    },
                });
            }
        } catch (err) {
            console.error("Failed to save organization:", err);
        }
    };

    const handleSave = async () => {
        setisLoading(true);
        for (let lang of languages) {
            await saveLanguage(lang)
        }
        setIsEdit(false);
        loadLanguages();
        setisLoading(false);
        setIsFading(true);
        setTimeout(() => {
            if ((currentTabIndex + 1) > profileCompletion) {
                updatePercentage(currentTabIndex + 1)
            }
            setCurrentTabIndex(currentTabIndex + 1);
            setIsFading(false);
        }, 200);
    };

    return (
        <div>

            <div className="p-6 mt-4 bg-white rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.05)] mx-auto border" style={{ minHeight: window.innerHeight - 300 }}>
                <div className="font-semibold text-lg mb-4 flex items-center gap-2 justify-between w-full">
                    <h2 className="text-blue-700 font-medium md:text-[20px] text-[17px] flex items-center space-x-2 cursor-pointer">
                        <img src={"/asset/icon/language_blue.svg"} className="w-[16px] mr-1" />
                        <span>{Lang(lang, 'language_proficiency')}</span>
                    </h2>
                    {!isEdit && (
                        <button
                            onClick={() => setIsEdit(true)}
                            className="flex border border-gray-300 rounded-full px-5 py-2 text-sm text-white bg-red-500 hover:bg-red-600"
                        >
                            <img src={"/asset/icon/edit.svg"} className="w-[16px] mr-1" />
                            Edit
                        </button>
                    )}
                </div>

                {languages.length === 0 ?
                    <div className="w-full text-sm">
                        <EmptyAsset title={Lang(lang, 'no_language')} desc={Lang(lang, 'no_language_desc')} />
                        {isEdit && <button
                            type="button"
                            onClick={handleAddLanguage}
                            className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
                        >
                            + {Lang(lang, 'add_anguage')}
                        </button>}
                    </div> : languages?.map((langData, index) => (
                        <div
                            key={index}
                            className="border rounded-lg p-4 mb-4 bg-gray-50 relative"
                        >
                            <h3 className="text-sm font-bold  text-blue-700 mb-2">
                                {Lang(lang, 'language')} {index + 1}{langData.languageName === 'English'&&<span className="text-red-500">*</span>}
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                                {/* Language Dropdown */}
                                <div>
                                    <label className="block text-sm font-medium mb-1">{Lang(lang, 'language')}<span className="text-red-500">*</span></label>
                                    <div className="relative ">

                                        <select
                                            disabled={!isEdit || langData.languageName === 'English'}
                                            value={langData.languageName}
                                            onChange={(e) => handleChange(index, "languageName", e.target.value)}
                                            className={(isEdit ? 'bg-white' : 'bg-gray-100') + " appearance-none w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                                        >
                                            <option value="" disabled>-- {Lang(lang, 'language')} --</option>
                                            {names.map((name, i) => (
                                                <option key={name} value={name} disabled={name === "English"} >
                                                    {name}
                                                </option>
                                            ))}
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500">
                                            ▼
                                        </div>
                                    </div>
                                </div>


                                {/* Speaking */}
                                <div>
                                    <label className="block text-sm font-medium mb-1">{Lang(lang, 'speaking')}<span className="text-red-500">*</span></label>
                                    <div className="flex flex-col gap-4">
                                        <label className="flex items-center gap-1">
                                            <input
                                                type="radio"
                                                checked={langData.speakingProficiency === "Active"}
                                                onChange={() =>
                                                    handleChange(index, "speakingProficiency", "Active")
                                                }
                                                disabled={!isEdit}
                                            />
                                            {Lang(lang, 'active')}
                                        </label>
                                        <label className="flex items-center gap-1">
                                            <input
                                                type="radio"
                                                checked={langData.speakingProficiency === "Passive"}
                                                onChange={() =>
                                                    handleChange(index, "speakingProficiency", "Passive")
                                                }
                                                disabled={!isEdit}
                                            />
                                            {Lang(lang, 'passive')}
                                        </label>
                                        {langData.languageName === 'English' &&
                                            <label className="flex items-center gap-1">
                                                <input
                                                    type="radio"
                                                    checked={langData.speakingProficiency === "Beginner"}
                                                    onChange={() =>
                                                        handleChange(index, "speakingProficiency", "Beginner")
                                                    }
                                                    disabled={!isEdit}
                                                />
                                                {Lang(lang, 'total_beginner')}
                                            </label>}
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium mb-1">{Lang(lang, 'writing')}<span className="text-red-500">*</span></label>
                                    <div className="flex flex-col gap-4">
                                        <label className="flex items-center gap-1">
                                            <input
                                                type="radio"
                                                checked={langData.writingProficiency === "Active"}
                                                onChange={() =>
                                                    handleChange(index, "writingProficiency", "Active")
                                                }
                                                disabled={!isEdit}
                                            />
                                            {Lang(lang, 'active')}
                                        </label>
                                        <label className="flex items-center gap-1">
                                            <input
                                                type="radio"
                                                checked={langData.writingProficiency === "Passive"}
                                                onChange={() =>
                                                    handleChange(index, "writingProficiency", "Passive")
                                                }
                                                disabled={!isEdit}
                                            />
                                            {Lang(lang, 'passive')}
                                        </label>
                                        {langData.languageName === 'English' &&
                                            <label className="flex items-center gap-1">
                                                <input
                                                    type="radio"
                                                    checked={langData.writingProficiency === "Beginner"}
                                                    onChange={() =>
                                                        handleChange(index, "writingProficiency", "Beginner")
                                                    }
                                                    disabled={!isEdit}
                                                />
                                                {Lang(lang, 'total_beginner')}
                                            </label>}
                                    </div>
                                </div>
                            </div>

                            {isEdit && langData.languageName !== 'English' && (
                                <button
                                    type="button"
                                    onClick={() => handleRemoveLanguage(langData)}
                                    className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                                    title="Delete"
                                >
                                    <img src={"/asset/icon/trash.svg"} className="w-[16px]" />️
                                </button>
                            )}
                        </div>
                    ))}

                {isEdit && languages.length !== 0 && (
                    <button
                        type="button"
                        onClick={handleAddLanguage}
                        className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
                    >
                        + {Lang(lang, 'add_anguage')}
                    </button>
                )}

                {!(isFormReady()) && <div className="flex justify-end w-full mb-2">
                    <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'required_error')}</p>
                </div>}


            </div>
            {isEdit && (
                <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3">
                    <button
                        type="button"
                        className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-50"
                        onClick={() => {
                            setIsFading(true);
                            setTimeout(() => {
                                setCurrentTabIndex(currentTabIndex - 1);
                                setIsFading(false);
                            }, 200);
                        }}
                    >
                        {Lang(lang, 'previous')}
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            if (isFormReady() && !isLoading) {
                                handleSave()
                            }
                        }}
                        className={
                            "rounded-full px-4 py-1 text-sm " +
                            ((isEdit && isFormReady()) ? "text-white bg-red-500 hover:bg-red-600" : "border border-gray-300 hover:bg-gray-50")}
                    >
                        {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" /> : Lang(lang, 'save_and_next')}
                    </button>
                </div>
            )}
            {!isEdit && <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3 ">
                <button
                    type="button"
                    className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-50"
                    onClick={() => {
                        setIsFading(true);
                        setTimeout(() => {
                            setCurrentTabIndex(currentTabIndex - 1);
                            setIsFading(false);
                        }, 200);
                    }}
                >
                    {Lang(lang, 'previous')}
                </button>
                <button
                    type="button"
                    className={
                        "rounded-full px-4 py-1 text-sm " +
                        ((isEdit && isFormReady()) ? "text-white bg-red-500 hover:bg-red-600" : "border border-red-500 text-red-500 hover:bg-gray-50")
                    }
                    onClick={async () => {
                        if (isFormReady() && !isLoading) {
                            setIsFading(true);
                            setTimeout(() => {
                                if ((currentTabIndex + 1) > profileCompletion) {
                                    updatePercentage(currentTabIndex + 1)
                                }
                                setCurrentTabIndex(currentTabIndex + 1);
                                setIsFading(false);
                            }, 200);
                        }
                    }}
                >
                    {isEdit ? Lang(lang, 'save_and_next') : `${Lang(lang, 'next')} ${currentTabIndex + 1}/10`}
                </button> </div>}
        </div>
    );
};

export default LanguageForm;
